export default __webpack_public_path__ + "static/media/reinhardt.ee4a6eff.webp";